import Noresult from "../../../components/noresult/noresult";
import { PageHeader } from "../../../layouts";

export default function Chatbot(){
    return(
        <>
          <PageHeader
          name="Chatbot"
          icon="icon-rb-book-open me-1 color-primary font-0 font-lg-16"
          pageHeaderclassName="header-content"
          appicon="true"
          urlback="/"
          extras={<>            
            </> 
          }
        />

        <div className="mobile-no-results d-flex align-items-center flex-column justify-content-center font-16">
           <div><Noresult/></div>
        </div>
        </>
    )
}